import type { SimulatorSchemaType } from '@vedalib/editor/lib/brand'
import type { SimulatorElementValue } from '@vedalib/editor/lib/elements'
import styled from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

export const NavigationRootStyled = styled.div<{
  $styles: ElementStyleCss<SimulatorSchemaType>
  $value: SimulatorElementValue
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ $value }) => $value.navigation};
  margin-top: ${({ $styles }) => $styles.indents?.marginTop};
`

export const NavigationButtonsStyled = styled.div<{
  $styles: ElementStyleCss<SimulatorSchemaType>
}>`
  display: flex;
  cursor: pointer;
  margin-left: ${({ $styles }) => $styles.indents?.marginLeft};
  gap: ${({ $styles }) => $styles.indents?.gap};
`
